import styled, { css, keyframes } from "styled-components";
import { ITokenStateStyleProps } from "../interfaces";

export const Row = styled.div`
    display: flex;
    flex-direction: column;
    padding-bottom: 4px;
    margin-bottom: 12px;
    border-bottom: solid 1px #aaa;
`;

export const Top = styled.div`
    display: flex;
    justify-content: space-between;
`;

export const TopLeft = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
`;

export const Key = styled.div`
    background-color: #bbb;
    color: white;
    border-radius: 4px;
    padding: 0 4px;
`;

export const TopRight = styled.div`
    display: flex;
    align-items: center;
    button.button {
        margin-bottom: 0;
        margin-right: 12px;
        font-size: 15px;
        padding: 0px 8px;
        border-width: 1px;
        height: 28px;
    }
`;

export const Messages = styled.div`
    display: flex;
    min-height: 60px;
    margin-top: 6px;
    ${p =>
        p.theme.sm.max(css`
            flex-direction: column;
        `)}
`;

export const Original = styled.textarea`
    font-size: 17px;
    padding: 9px 0;
    margin-bottom: 16px;
    font-style: italic;
    background-color: transparent;
    outline: none;
    border: none;
    flex: 1;
    resize: none;
`;

export const TranslationMessage = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;

    label {
        display: none;
    }
    > div {
        margin-bottom: 0;
    }
    textarea {
        &:disabled {
            border: none;
            color: ${p => p.theme.mode === "dark" ? p.theme.c.grey5 : p.theme.c.dark} !important;
            opacity: 1;
            font-weight: 400;
        }
    }
`;

export const UserWrapper = styled.div`
    padding: 0;
    margin-left: 8px;
    /* margin-bottom: 8px; */
    [class^="User__UserImage"] {
        margin-right: 0;
    }
`;

export const TokenState = styled.div<ITokenStateStyleProps>`
    color: ${p => (p.isMerged ? p.theme.c.correct : p.theme.c.info)};
    margin-left: 8px;
`;

export const Preview = styled.div`
    padding-right: 6px;
`;